module.exports = __webpack_public_path__ + "static/light-80202b8151d92bcdaae7785fde08650f.jpg";